<template>
  <div :id="post.id">
    <div v-if="!post.deleted && post.user_id && post.hasFiles">
      <!-- post itself -->
      <div class="eachPost">
        <!-- USERNAME USUALLY GOES HERE-->

        <!-- if there's an image -->
        <div class="gridImage">
          <figure
            style="display: inline-block"
            class="storyImage"
            :key="index"
            v-for="(file, index) in post.files"
          >
            <!-- Displays a light box image view when images are clicked -->
            <img
              v-if="isImage(file)"
              :src="file.src"
              @click="openGallery(index, post.files)"
            />

            <div style="display: flex" v-else class="fileType">
              <!-- If the file is a video -> display video image -->
              <img v-if="isVideo(file)" src="../assets/video.png" />
              <img v-else src="../assets/file.png" />
              <a :href="file.src">{{ file.name }}</a>
            </div>
          </figure>
        </div>

        <!-- text -->
        <p>{{ post.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["post", "index", "currentUser"],

  data: () => ({}),

  methods: {
    openGallery(index, files) {
      this.$emit("openGallery", index, files);
    },

    // If the file is an image
    isImage(file) {
      return file.src.includes("png");
    },

    // If the file is a video
    isVideo(file) {
      return file.src.includes("MP4") || file.src.includes("mp4");
    },
  },
};
</script>

<style>
.storyImage {
  object-fit: cover;
  width: 1vm;
  height: 1vm;
  overflow: hidden;
  display: block;
  height: 100%;
}

/*.eachPost {
  width: 33vm;
  height: 33vm;
  overflow: hidden;
  border: 2px solid white;
}*/
</style>
